import {useGetList, useRecordContext} from "react-admin";
import Chip from "@mui/material/Chip";
import React from "react";

export const ProviderTablespacesField = () => {
    const provider = useRecordContext();
    const {data: allTablespaces} =
        useGetList('admin/medical/tablespaces');
    const tablespaceName = (providerTablespace) => allTablespaces?.find(tablespace => tablespace.id === providerTablespace.athena_tablespace_id).name
    return (
        <ul style={{listStyle:"none", marginBottom:"2px", display: "flex"}}>
            {provider.tablespaces?.map(tablespace => (
                <li key={tablespace.athena_tablespace_id}><Chip label={tablespaceName(tablespace)} /></li>
            ))}
        </ul>
    )
};
